import { createSelector } from 'reselect';

import { selectEntitiesBetslipsEntity } from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { StateType } from '../../../../states';
import { GRAssetsBySkinId } from '../../constants/assets';
import { getGRLabelsBySkinId } from '../../constants/labels';
import { selectGRGlobalSkinId } from '../../selectors/global/globalPrimary.selector';

type EntitiesBetslipsSelectorProps = {
  betslipId?: number;
  id?: number;
};

const makeGRHistoryBetslipPropsSelector = () => {
  const selectBetslipHistoryGRData = (state: StateType, props: EntitiesBetslipsSelectorProps) =>
    selectEntitiesBetslipsEntity(state, props)?.data?.GR;

  const selectBetslipHistoryGRDisabled = (state: StateType, props: EntitiesBetslipsSelectorProps) =>
    selectBetslipHistoryGRData(state, props)?.disabled;

  const selectBetslipHistoryGRSkinId = (state: StateType, props: EntitiesBetslipsSelectorProps) =>
    selectBetslipHistoryGRData(state, props)?.skinId;

  const selectBetslipHistoryGRRaceId = (state: StateType, props: EntitiesBetslipsSelectorProps) =>
    selectBetslipHistoryGRData(state, props)?.raceId;

  const selectRoundId = (state: StateType, props: EntitiesBetslipsSelectorProps) =>
    selectBetslipHistoryGRData(state, props)?.round;

  const selectLabel = createSelector([selectBetslipHistoryGRSkinId, selectRoundId], (skinId, roundId) => {
    let label = '';
    if (skinId !== undefined) {
      label += getGRLabelsBySkinId(skinId)?.OperationTitle ?? '';

      if (roundId !== undefined) {
        label += ` - ${getGRLabelsBySkinId(skinId)?.StepTitleByStepId[roundId] ?? ''}`;
      }
    }

    return label;
  });

  const selectGRBasketSwitchIcon = (state: StateType) => {
    const skinId = selectGRGlobalSkinId(state);

    if (!skinId) {
      return '';
    }

    return GRAssetsBySkinId[skinId]?.IconPath;
  };

  return createSelector(
    [selectLabel, selectGRBasketSwitchIcon, selectBetslipHistoryGRRaceId, selectBetslipHistoryGRDisabled],
    (label, icon, raceId, isDisabled) => {
      return {
        label,
        icon,
        isDisabled,
        isVisible: !!raceId,
      };
    },
  );
};

export default makeGRHistoryBetslipPropsSelector;
